import React from "react";
import { Button, Modal, Form, Input, Spin } from "antd";
import { SvgIcon } from "../common";

// Style
import "./profile.scss";
import {
  createLoadingSelector,
  getUserPin,
  updateUserpin,
  resetStoreState,
} from "../../redux/actions";
import {
  GET_USER_PIN,
  GET_USER_PIN_RESET,
  UPDATE_USER_PIN,
  UPDATE_USER_PIN_RESET,
} from "../../redux/actions/type";
import { connect } from "react-redux";
import { showAlert } from "../../common/alert-messages";
import { isObjectNotEmpty } from "../../common/common-methods";

class ViewPin extends React.Component {
  formRef = React.createRef();
  state = {
    visible: false,
  };

  handleViewPinClick = () => {
    const { visible } = this.state;
    if (visible && this.formRef.current) {
      this.formRef.current.resetFields();
    } else {
      this.props.getUserPin();
    }
    this.setState({ visible: !visible });
  };

  componentDidUpdate() {
    if (isObjectNotEmpty(this.props.userPin)) {
      this.formRef.current.setFieldsValue({
        view_pin: this.props.userPin.user_pin,
      });
      this.props.resetStoreState(GET_USER_PIN_RESET);
    }
    if (isObjectNotEmpty(this.props.updateUserPinMessage)) {
      showAlert.success(this.props.updateUserPinMessage);
      this.setState({ visible: false });
      this.props.resetStoreState(UPDATE_USER_PIN_RESET);
    }
  }

  handleSave = (values) => {
    this.props.updateUserpin(values.view_pin);
  };
  render() {
    const { visible } = this.state;

    return (
      <React.Fragment>
        <span className="d-flex" onClick={this.handleViewPinClick}>
          View Pin
        </span>
        <Modal
          destroyOnClose={true}
          centered={true}
          bodyStyle={{ padding: "1rem" }}
          closeIcon={
            <SvgIcon
              name="close"
              fill="#dc0100"
              width="13px"
              viewbox="0 0 298.667 298.667"
            />
          }
          className="full-screen-xs-modal footer-less view-pin-modal"
          closable={true}
          onCancel={this.handleViewPinClick}
          width={400}
          title="View Pin"
          visible={visible}
          footer={null}
        >
          <Spin spinning={this.props.isFetchingData} size="large">
            <Form
              layout="vertical"
              name="sendToCustom"
              ref={this.formRef}
              onFinish={this.handleSave}
            >
              <label htmlFor="view_pin" className="w-100 fs-12">
                Pin
              </label>
              <Form.Item
                id="view_pin"
                name="view_pin"
                rules={[
                  { required: true, message: "Please enter your Pin!" },
                  {
                    pattern: /^[0-9]{4}$/,
                    message: "Pin must be exactly 4 digits!",
                  },
                  {
                    pattern: /^\d+$/,
                    message: "PIN must contain only numbers",
                  },
                ]}
                hasFeedback
              >
                <Input type="text" placeholder="Enter Pin" maxLength={4} />
              </Form.Item>
              <div className="text-right modal-footer mt-5">
                <Button
                  className="mt-3 mr-3 text-uppercase"
                  onClick={this.handleViewPinClick}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="mt-3 text-uppercase"
                >
                  Save Pin
                </Button>
              </div>
            </Form>
          </Spin>
        </Modal>
      </React.Fragment>
    );
  }
}

const loadingSelector = createLoadingSelector([GET_USER_PIN, UPDATE_USER_PIN]);

const mapStateToProps = (state) => ({
  successMessage: state.contactDetail,
  userPin: state.userPin,
  updateUserPinMessage: state.updateUserPinMessage,
  isFetchingData: loadingSelector(state),
});

export default connect(mapStateToProps, {
  getUserPin,
  updateUserpin,
  resetStoreState,
})(ViewPin);
